"use client";

import { Search } from "lucide-react";
import type { AddressSuggestion } from "@/features/geo/shared/address-types";
import { AddressDropdownItem } from "@/features/geo/ui/AddressDropdownItem";
import { useAddressSearch } from "@/features/geo/ui/useAddressSearch";

interface Props {
  onSelect: (address: AddressSuggestion) => void;
  placeholder?: string;
}

export function SearchInput({ onSelect, placeholder }: Props) {
  const { query, setQuery, results, isLoading } = useAddressSearch();

  return (
    <div className="relative">
      <div className="relative">
        <Search
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-subtle"
          strokeWidth={1.5}
          aria-hidden="true"
        />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder || "Indtast din adresse"}
          className="w-full rounded border-2 border-ink py-2.5 pl-10 pr-10 text-sm text-ink placeholder:text-border-subtle focus:border-theme focus:outline-none"
        />
        {isLoading && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-border border-t-theme" />
          </div>
        )}
      </div>
      {results.length > 0 && query.length >= 3 && (
        <div className="absolute left-0 right-0 top-full z-50 mt-1 max-h-72 overflow-y-auto rounded border border-border bg-white shadow-md">
          {results.map((address) => (
            <AddressDropdownItem
              key={address.adresse.id}
              address={address}
              onSelect={(addr) => {
                setQuery(addr.tekst);
                onSelect(addr);
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
